export default {
	root: '/',
	wildcard: '*',
	notFound: '/404',
	error: '/error',

	crypt: '/taproot',
	work: '/work',
	projects: '/projects',
	sandbox: '/sandbox',
	trailer: '/trailer',
}
